import BasicFieldType from '@opsbase/lib-data-fieldtype/BasicFieldType';
import QK from '@opsbase/lib-data-queryfield/QueryFieldKey';
import DataType from '@opsbase/lib-datatype/DataType';
import Event from '@opsbase/lib-event/Event';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette/Palette';
import OperatorType from '@opsbase/lib-workflow/WorkflowCondition/OperatorType';
import useForceUpdate from '@opsbase/react-hooks/useForceUpdate';
import useCss from '@opsbase/web-css/useCss/useCss';
import DataTreeController from '@opsbase/web-ctrl-datatree/DataTreeController';
import useViewRegistryActions from '@opsbase/web-ctrl-view/useViewRegistryActions';
import DVLTable from '@opsbase/web-dvl-table';
import AddIcon from '@opsbase/web-icons/icons/AddIcon';
import useNav from '@opsbase/web-nav/useNav/useNav';
import Button from '@opsbase/web-ui/Button/Button';
import React, { useCallback, useEffect, useRef } from 'react';
const makeMyClasses = () => ({
    root: {
        padding: '8px 16px',
    },
    addButton: {
        position: 'fixed',
        bottom: 40,
        right: 40,
    },
});
export function OpDefinitionEditWorkflowsTab(props) {
    const { definition, editable, type } = props;
    const { goTo } = useNav();
    const { setView, cloneView } = useViewRegistryActions();
    const isEditable = editable;
    const definitionId = useRef();
    const VIEWID = 'opdefinitionworkflows';
    const myCss = useCss(makeMyClasses);
    const { forceUpdate } = useForceUpdate();
    useEffect(() => {
        if (definitionId.current !== definition.id) {
            definitionId.current = definition.id;
            const view = cloneView(DataType.WORKFLOW);
            view.id = VIEWID;
            view.isSystem = true;
            view.groupsChanged = new Date();
            view.filtersChanged = new Date();
            view.groupBys = [];
            if (!isEditable)
                view.fields = view.fields.filter(f => f.fieldType !== BasicFieldType.WORKFLOW_ENABLED);
            view.filters = [
                {
                    queryFieldKey: QK.WORKFLOW_EVENT,
                    id: Event.OP_DUE,
                    hidden: true,
                    veryHidden: true,
                },
                {
                    queryFieldKey: QK.WORKFLOW_EVENT,
                    id: Event.OP_LATE,
                    hidden: true,
                    veryHidden: true,
                },
                {
                    queryFieldKey: QK.WORKFLOW_EVENT,
                    id: Event.OP_MISSED,
                    hidden: true,
                    veryHidden: true,
                },
                {
                    queryFieldKey: QK.WORKFLOW_EVENT,
                    id: Event.OP_COMPLETE,
                    hidden: true,
                    veryHidden: true,
                },
                {
                    queryFieldKey: QK.WORKFLOW_CONDITION,
                    id: (type === 'template' ? QK.ORGTEMPLATE : QK.OPDEFINITION) +
                        '_#' +
                        OperatorType.EQUAL +
                        '_#' +
                        definition.id,
                    hidden: true,
                    veryHidden: true,
                },
            ];
            setView(view);
            forceUpdate();
        }
    }, [setView, cloneView, definition, isEditable, type, forceUpdate]);
    const handleClickCreate = useCallback(() => {
        goTo(Pages.WORKFLOWS_PICKTRIGGER, undefined, {
            dataType: DataType.OP,
            newWorkflow: {
                orConditions: [
                    {
                        andConditions: [
                            {
                                queryFieldKey: type === 'template' ? QK.ORGTEMPLATE : QK.OPDEFINITION,
                                operator: OperatorType.EQUAL,
                                mandatory: true,
                                value: {
                                    id: [definition.id],
                                    title: [definition.title],
                                    color: [],
                                    type: type === 'template'
                                        ? DataType.ORGTEMPLATE
                                        : DataType.OPDEFINITION,
                                },
                            },
                        ],
                    },
                ],
            },
        });
    }, [definition, goTo, type]);
    if (!definitionId.current)
        return null;
    return (React.createElement(DataTreeController, { viewId: VIEWID },
        React.createElement("div", { className: myCss.root },
            isEditable && (React.createElement(DVLTable, { notFoundText: i18n.t('no-workflows-found'), itemPage: Pages.WORKFLOWS_EDIT, itemDeletePage: Pages.WORKFLOWS_DELETE })),
            !isEditable && React.createElement(DVLTable, { notFoundText: i18n.t('no-workflows-found') }),
            isEditable && (React.createElement(Button, { classes: { root: myCss.addButton }, color: Palette.primary, icon: React.createElement(AddIcon, null), label: i18n.t('add-workflow'), onClick: handleClickCreate })))));
}
export default OpDefinitionEditWorkflowsTab;
